// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2Grr0","detailsBorder":"styles_detailsBorder__15Abe"};